<script setup lang="ts">
import { computed } from 'vue'
import { uuid } from 'vue3-uuid'
import CsImage from '@/onenetwork/components/csimage/CsImage.vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  if(typeof props.data != 'object' || Object.keys(props.data).length === 0 ) return
  return props.data
})
</script>

<template>
  <div class="table-cell listing-subject-cell">
    <div class="thumb">
      <cs-image :alt="props.data?.title" :src="props.data?.thumb"/>
    </div>
    <div class="info">
      <div class="title">{{ props.data?.title }}</div>
      <div class="attrs" style="display: none">
        <div class="attr" v-for="(attr, idx) in props.data?.attrs" :key="`attr_item_${idx}_${uuid.v4().toString()}`">
          <span class="key">{{ attr.key }}</span>
          <span class="val">{{ attr.val }}</span>
        </div>
      </div>
      <div class="map">
        <div class="map_info_item">
          <span class="key">Số tờ</span>
          <span class="val">{{ props.data?.map?.map_sheet }}</span>
        </div>
        <div class="map_info_item">
          <span class="key">Số thửa</span>
          <span class="val">{{ props.data?.map?.plot_num }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
